import { AppBar, Button, Toolbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import Cookies from "js-cookie";

const Navbar = () => {
  const NavbarButtons = [
    { name: "Live Production", isAuth: true },
    { name: "Quality Prediction", isAuth: true },
    // { name: "Contribution Analysis", isAuth: true },
    { name: "Control Charts", isAuth: true },
    { name: "Summary Charts", isAuth: true },
    // { name: "AML Process Sheet", isAuth: true },
    { name: "Configuration", isAuth: true },
  ];
  const [selectedButton, setSelectedButton] = useState("");
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname.split("/")[1];
    if (path === "live-production") {
      setSelectedButton("Live Production");
    } else if (path === "quality" || path === "qualityInfo") {
      setSelectedButton("Quality Prediction");
    } else if (path === "contribution") {
      setSelectedButton("Contribution Analysis");
    } else if (path === "configuration") {
      setSelectedButton("Configuration");
    } else if (path === "control") {
      setSelectedButton("Control Charts");
    } else if (path === "summary") {
      setSelectedButton("Summary Charts");
    } else if (path === "aml") {
      setSelectedButton("AML Process Sheet");
    } else {
      setSelectedButton("");
    }
  }, [location]);

  const buttonStyle = (buttonName) => ({
    textTransform: "capitalize",
    color: "#404040",
    fontSize: "0.80rem",
    fontWeight: "500",
    marginRight: "5px",
    padding: "3px 15px",
    backgroundColor:
      selectedButton === buttonName ? "#0077B61A" : "transparent",
    borderRadius: "25px",
    border: selectedButton === buttonName ? "1px solid #0077B6" : "none",
  });

  const appStyle = {
    backgroundColor: "white",
    minHeight: "45px",
    boxShadow: "0px 3px 6px #0000001F",
    borderBottom: "2px solid #FDF3E5",
    marginBottom: "4px",
  };
  const homeIconStyle = {
    color: "#404040",
    fontSize: "30px",
    marginRight: "10px",
    "&:hover": {
      color: "#EA8600",
      cursor: "pointer",
    },
  };

  return (
    <AppBar position="static" sx={appStyle}>
      <Toolbar variant="dense">
        {Cookies.get("authToken") === "Manager" && (
          <Link to="/">
            <HomeIcon sx={homeIconStyle} />
          </Link>
        )}
        {NavbarButtons.map(({ name, isAuth }) => {
          if (isAuth) {
            return (
              <Button
                key={name}
                sx={buttonStyle(name)}
                component={Link}
                to={
                  name === "Live Production"
                    ? "/live-production"
                    : `/${name.toLowerCase().split(" ")[0]}`
                }
                onClick={() => setSelectedButton(name)}
              >
                {name}
              </Button>
            );
          }
          return null;
        })}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
